import * as React from 'react';

import spinner from 'images/spinner@2x.gif';

function SpinnerIconComponent(): React.Node {
  return (
    <img
      src={spinner}
      width="24"
      height="24"
      // Ignore the GIF changing when running Chromatic visual diffing.
      // Docs: https://www.chromatic.com/docs/ignoring-elements
      data-chromatic="ignore"
    />
  );
}

export const SpinnerIcon = React.memo(SpinnerIconComponent);
